// extracted by mini-css-extract-plugin
export default {"backdrop":"Loading_backdrop__hHwpc"};